module.exports = __webpack_public_path__ + "img/ogre_magi.5fd34713.png";